/**
 * Skeleton do Início — espelha o Bento: header grande com saudação,
 * fileira de KPIs, agenda cirúrgica de 2 semanas e cards menores.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* Header do Bento (saudação + próximo evento) */}
      <div className="h-[132px] rounded-[20px] bg-slate-200" />

      {/* Fileira de KPIs */}
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-7">
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className="h-24 rounded-2xl border border-slate-200 bg-white p-4">
            <div className="h-3 w-2/3 rounded bg-slate-200" />
            <div className="mt-3 h-6 w-1/2 rounded bg-slate-200" />
          </div>
        ))}
      </div>

      {/* Agenda cirúrgica + card lateral */}
      <div className="grid gap-4 lg:grid-cols-3">
        <div className="h-72 rounded-2xl border border-slate-200 bg-white p-4 lg:col-span-2">
          <div className="h-4 w-56 rounded bg-slate-200" />
          <div className="mt-4 grid grid-cols-7 gap-2">
            {Array.from({ length: 14 }).map((_, i) => (
              <div key={i} className="h-20 rounded-lg bg-slate-100" />
            ))}
          </div>
        </div>
        <div className="h-72 rounded-2xl border border-slate-200 bg-white p-4">
          <div className="h-4 w-40 rounded bg-slate-200" />
          <div className="mt-4 flex flex-col gap-3">
            <div className="h-12 rounded-lg bg-slate-100" />
            <div className="h-12 rounded-lg bg-slate-100" />
            <div className="h-12 rounded-lg bg-slate-100" />
          </div>
        </div>
      </div>

      {/* Donuts (Mix / Convênios / Pacientes / Sexo) */}
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-44 rounded-2xl border border-slate-200 bg-white p-4">
            <div className="h-3 w-24 rounded bg-slate-200" />
            <div className="mx-auto mt-4 h-24 w-24 rounded-full bg-slate-100" />
          </div>
        ))}
      </div>
    </div>
  );
}
